export interface RetryPolicy {
  label: string;
  eventName: string;
  description: string;
  taskType?: string;
  defaultComment?: string;
  isRescue?: boolean;
  rescueAuthorizers?: string[];
  rescueAuthorizerLabel?: string;
}

// retry policies
export const RETRY_POLICIES: RetryPolicy[] = [
  {
    label: 'Reintento Ajuste de Precio',
    eventName: 'price_adjustment_by_approver',
    description: 'Recorrerá los procesos: Pricing Manual y Aprobología',
    taskType: 'pricing_comite',
  },
  {
    label: 'Reintento Repricing Comité',
    eventName: 'retry_pricing_committee_by_approver',
    description: 'Recorrerá los procesos: Pricing Manual, HESH y Aprobología',
  },
  {
    label: 'Vigencia de precio',
    eventName: 'precio vencido',
    description: 'Ejecuta la política de vigencia de precio',
  },
  {
    label: 'Reintento Revisión Documentos',
    eventName: 'reintento revision documentos',
    description:
      'Recorrerá los procesos de: Revisión de documentos, Pricing, Hesh y Aprobología',
  },
  {
    label: 'Reintento Revisión Coordenadas',
    eventName: 'retry_coordinates_docs',
    description: 'Reintentará el proceso de revisión de documentos para validación de coordenadas',
    defaultComment: 'Inconsistencia con las coordenadas, por favor corregirlas',
  },
  {
    label: 'Rechazo por oportunidad de negocio',
    eventName: '',
    description:
      'El nid se rechazará por tener una oportunidad de negocio inválida',
  },
  {
    label: 'Caso extraordinario',
    eventName: 'retry_aprobologia',
    description: 'Rechazos temporales y errores de aprobación',
  },
  {
    label: 'Política de Rescate Aprobología Manual',
    eventName: 'rescue_apro',
    description: 'Recorrerá el proceso de Aprobología Manual',
    isRescue: true,
    rescueAuthorizerLabel: '¿Quién autoriza el rescate?',
    rescueAuthorizers: ['Carlos Salcedo', 'Nicolás Bolaños'],
  },
];
